import { IPerspectiveTrees, IPerspectivesUserGroup, IGetPerspective, IPerspectiveAggr, IPerspectiveDashboard } from 'app/services/graphqlApi.service';
import {TREE_NODE_TYPE} from 'app/perspectives/constants';
import { IPerspectiveAggregation } from 'app/perspectives/interfaces/interfaces';
import { IAggregateTags } from 'app/assets/interfaces/interfaces';

export function parseUserGroupPerspective(perspective: IGetPerspective) {
  // console.log('perspective: 3', perspective);
  return {
    isDefaultPerspective: perspective.isDefault,
    // userGroupId: perspective.user_group_id,
    ...parsePerspectiveApiResponse(perspective)
  }
}

export function parsePerspectiveApiResponse(perspective: IGetPerspective) {
  return {
    id: perspective.id,
    name: perspective.name,
    displayName: perspective.display_name,
    perspectiveTree: getPerspectiveTree(perspective.perspective_trees || []),
    perspectiveAggregations: getPerspectiveAggregations(perspective.perspective_trees || []),
    perspectiveDashboards: getPerspectiveDashboards(perspective.perspective_trees || []),
    assetCount: getAssetCount(perspective.perspective_trees || []),
    userGroupCount: perspective.perspectives_usergroups?.length || 0,
    userGroups: getUserGroup(perspective.perspectives_usergroups || []),
    groups: [],
    createdOn: perspective.created_date,
    createdBy: perspective.created_by,
    lastEditedBy: perspective.updated_by,
    lastEditedOn: perspective.updated_date,
    type: 'root',
  };
}

function getPerspectiveDashboards(perspectiveTree: IPerspectiveTrees[]){
  console.log('perspectiveTree: 3', perspectiveTree);
  const perspectiveDashboard: IPerspectiveDashboard[] = [];
  perspectiveTree.map(perspective => {
    if (perspective.dashboards?.length){
      perspective.dashboards.map((pDashboard: IPerspectiveDashboard) => {
        perspectiveDashboard.push({ id: pDashboard.id, name: pDashboard.name, path: pDashboard.path, is_default: pDashboard.is_default, perspectiveGroupId: perspective.id, perspectiveGroupName: perspective.name, panels: pDashboard.panels });
      });
    }
  });

  return perspectiveDashboard;
}

function getPerspectiveAggregations(perspectiveTree: IPerspectiveTrees[]){
  console.log('perspectiveTree: ', perspectiveTree);
  const perspectiveAggregations: IPerspectiveAggregation[] = [];
  perspectiveTree.map(perspective => {
    if (perspective.aggr_configs?.length){
      perspective.aggr_configs.forEach((aggr: IPerspectiveAggr) => {
        const tags: IAggregateTags[] = aggr.tags?.length ? JSON.parse(JSON.stringify(aggr.tags)) : []
        perspectiveAggregations.push({id: aggr.id, name: aggr.name, functionId: aggr.function_id, perspectiveGroupId: perspective.id, perspectiveGroupName: perspective.name, tags: tags, type: aggr.type, aggrConfigs: aggr.aggr_configs, funcConfigs: aggr.func_config })
      });
    }
  });

  return perspectiveAggregations;
}

function getPerspectiveTree(perspectiveTree: IPerspectiveTrees[]) {
  return perspectiveTree.map(pt => {
    const name = pt.tree_node_type == TREE_NODE_TYPE.leaf ? pt.entity?.name || pt.name : pt.name;
    return {
      entityId: pt.entity_id,
      name,
      id: pt.id,
      latitude: pt.latitude,
      longitude: pt.longitude,
      type: pt.tree_node_type,
      isLatLong: !!pt.latitude,
      nodeIndex: pt.node_index,
      parentId: pt.parent_id,
      perspectiveId: pt.perspective_id,
    }
  });
}

function getAssetCount(perspectiveTrees: IPerspectiveTrees[]) {
  return perspectiveTrees.reduce((count, pst) => {
    if(pst.entity_id || pst.tree_node_type === TREE_NODE_TYPE.leaf) {
      count++;
    }
    return count;
  }, 0);
}

function getUserGroup(userGroups: IPerspectivesUserGroup[]) {
  return userGroups.map(ug => ({
    perspectiveId: ug.perspective_id,
    id: ug.user_group_id,
  }));
}